import { HTMLProps } from "react";
import { Icon } from "react-migration/components/Icon";
import { InsightStatusType } from "react-migration/components/Insight/components/Body/Body";
import { Insight } from "react-migration/components/Insight/Insight";

type PlanningAuthoritySummarySectionProps = HTMLProps<HTMLDivElement> & {
  heading: string;
  tooltip?: string;
  status?: InsightStatusType;
  footerDescription: string;
  footerValue: string;
  footerArrowUp?: boolean;
};

export function PlanningAuthoritySummarySection({
  heading,
  status,
  footerDescription,
  footerValue,
  footerArrowUp,
  tooltip,
  children,
}: PlanningAuthoritySummarySectionProps) {
  return (
    <Insight.Wrapper title={heading} tooltip={tooltip}>
      <Insight.Body status={status}>{children}</Insight.Body>
      <Insight.Footer description={footerDescription}>
        {footerValue}
        {footerArrowUp === true && (
          <Icon size="xs" icon="icon-lt-arrow-up-line" extraClasses="text-text-accent-green" />
        )}
        {footerArrowUp === false && (
          <Icon size="xs" icon="icon-lt-arrow-down-line" extraClasses="text-text-accent-red" />
        )}
      </Insight.Footer>
    </Insight.Wrapper>
  );
}
